import React from 'react';

const BurgerMenuIcon = () => (
  <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 0.409091C0 0.183068 0.191893 0 0.428571 0H11.5714C11.8071 0 12 0.183068 12 0.409091C12 0.635114 11.8071 0.818182 11.5714 0.818182H0.428571C0.191893 0.818182 0 0.635114 0 0.409091ZM0 4.5C0 4.275 0.191893 4.09091 0.428571 4.09091H11.5714C11.8071 4.09091 12 4.275 12 4.5C12 4.725 11.8071 4.90909 11.5714 4.90909H0.428571C0.191893 4.90909 0 4.725 0 4.5ZM11.5714 9H0.428571C0.191893 9 0 8.81591 0 8.59091C0 8.36591 0.191893 8.18182 0.428571 8.18182H11.5714C11.8071 8.18182 12 8.36591 12 8.59091C12 8.81591 11.8071 9 11.5714 9Z"
      fill="currentColor"
    />
  </svg>
);

export default BurgerMenuIcon;
